<template>
  <div class="traplans">
    <div
      v-for="item in items"
      :key="item.id"
      class="gw_box"
      style="
        --box-padding: 0 1.75rem;
        --box-radius: 8px;
        box-shadow: var(--menu-shadow);
        overflow: hidden;
      "
    >
      <DashboardArticle
        :item="item"
        componentTag="router-link"
        style="
          --clr-bolded: var(--clr-primary);
          --clr-back: transparent;
          --title-font-size: 2rem;
          --description-font-size: 1rem;
          --left-overflow: unset;
        "
      >
        <template #left>
          <component
            :is="item.thumbnail_svg"
            class="w-100"
          />
        </template>
        <template #description="v">
          <span v-html="v.item.description"></span>
        </template>
        <template #before_tags>
          <div
            v-for="tag in item.types || []"
            :key="tag.id"
            class="gw_tag gw_tag_ll mt-auto"
            :style="`
              position:relative;
              --tag-top: 0;
              --tag-right: 0;
              --tag-padding:0.325rem 0.5rem 0.325rem 0.85rem;
              --clr-tag-ll:${tag.color};
              --clr-tag-back: var(--clr-black-0);
              `"
          >
            {{ tag.name }}
          </div>
        </template>
        <template #after_tags>
          <router-link
            v-bind="item.routerLinkProps"
            class="gw_btn-v1 gw_btn_primary ml-auto f-center clr-white"
          >
            {{ $t('btn.start_plan') }}
            <div class="mdi text-large mdi-chevron-right"></div>
          </router-link>
        </template>
      </DashboardArticle>
    </div>
    <div
      class="gw_box text-italics mt-4 f-center clr-grey anim-fade-in_slow"
      :style="`
        box-shadow: var(--menu-shadow);
      --box-radius: 8px;
      --box-padding: 4rem;
      background: linear-gradient(to bottom, var(--clr-black-1), var(--clr-black-0-2));
      `"
    >
      <div class="f-column f-center text-center">
        <div
          class="text-big weight_600 clr-white"
          v-html="$t('study_plans.coming_soon')"
        ></div>
        <div
          class="clr-grey text-normal mt-2"
          v-html="$t('study_plans.more_plans_coming_soon')"
        ></div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import DashboardArticle from '@/components/Dashboard/DashboardArticle'
import study_plans from '@/components/StudyPlans/study_plans'

export default {
  components: {
    DashboardArticle,
  },
  mixins: [float_mix, format_mix],
  data() {
    return {}
  },

  computed: {
    items() {
      // console.log(study_plans)
      const res = study_plans.map(i => {
        const r = {
          id: i.id,
          title: i.title,
          description: i.description,
          url: '',
          // thumbnail_url: i.thumbnail_url,
          // thumbnail_style: i.thumbnail_style,
          thumbnail_svg: i.thumbnail_svg,
          steps: i.steps,
          // steps: i.steps.map((ss, idx) => {
          //   let rr = {}
          //   Object.keys(ss).forEach(k => {
          //     if (ss[k]) {
          //       rr[k] = typeof ss[k] === 'string' ? ss[k] : JSON.stringify(ss[k])
          //     }
          //   })
          //   rr.index = idx
          //   return rr
          // }),
          routerLinkProps: {
            to: {
              name: 'StudyPlanPage',
              params: { id: i.id },
            },
          },
          types: [
            {
              name: i.gameformat,
              color: `var(--clr-${i.gameformat.toLowerCase()})`,
            },
          ],
        }
        return r
      })
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.traplans {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
